import LegalPage from "@/pages/LegalPage";

export default function PrivacyPolicyPage() {
  return (
    <LegalPage
      title={<>Privacy <em>Policy.</em></>}
      subtitle="Please read our Privacy Policy to understand how Utsah collects, uses and protects your information."
      lastUpdated="29 July 2026"
      metaTitle="Privacy Policy | Utsah"
      metaDescription="Read Utsah's Privacy Policy to understand how we collect, use, store and protect your personal information."
    >
      <h2>1. Introduction</h2>
      <p>This Privacy Policy explains how Kiran Ventures, operating under the brand Utsah ("Utsah", "we", "our" or "us"), collects, uses, stores and protects your personal information when you visit our website or interact with our services.</p>
      <p>By using our website, submitting an enquiry or requesting information, you agree to the practices described in this Privacy Policy.</p>

      <h2>2. Company Information</h2>
      <p>
        Kiran Ventures<br />
        54 Vinay Nagar<br />
        Kesar Bagh Road<br />
        Indore, Madhya Pradesh 452009<br />
        India
      </p>
      <p>Legal Email: <a href="mailto:atishaya@utsahgifting.com">atishaya@utsahgifting.com</a></p>
      <p>Customer Support: <a href="mailto:pragati@utsahgifting.com">pragati@utsahgifting.com</a></p>
      <p>Phone: +91 90988 80482</p>

      <h2>3. Information We Collect</h2>
      <p>Depending on how you interact with our website, we may collect information including:</p>
      <p><strong>Personal Information</strong></p>
      <ul>
        <li>Name</li>
        <li>Company name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>City or location</li>
        <li>Business information voluntarily provided by you</li>
      </ul>
      <p><strong>Enquiry Information</strong></p>
      <p>Information submitted through:</p>
      <ul>
        <li>Quote Request forms</li>
        <li>Contact forms</li>
        <li>Catalogue download forms</li>
      </ul>
      <p><strong>Technical Information</strong></p>
      <p>When you visit our website, we may automatically collect certain technical information including:</p>
      <ul>
        <li>IP address</li>
        <li>Browser type</li>
        <li>Device information</li>
        <li>Operating system</li>
        <li>Pages visited</li>
        <li>Time spent on pages</li>
        <li>Referring website</li>
        <li>General website usage information</li>
      </ul>

      <h2>4. How We Use Your Information</h2>
      <p>We use your information to:</p>
      <ul>
        <li>Respond to enquiries.</li>
        <li>Prepare quotations.</li>
        <li>Share our product catalogue.</li>
        <li>Communicate regarding corporate gifting requirements.</li>
        <li>Improve our website and services.</li>
        <li>Analyse website performance using Google Analytics.</li>
        <li>Maintain business records.</li>
        <li>Comply with applicable legal obligations.</li>
      </ul>

      <h2>5. Marketing Communications</h2>
      <p>Utsah does not offer newsletter subscriptions through its website.</p>
      <p>If you have contacted us regarding our products or services, we may communicate with you regarding your enquiry, quotation or ongoing business relationship.</p>
      <p>We do not send promotional communications solely because you visited our website.</p>

      <h2>6. Catalogue Downloads</h2>
      <p>Visitors may download our catalogue after submitting the requested contact information.</p>
      <p>By requesting a catalogue, you consent to Utsah contacting you regarding your enquiry and related corporate gifting solutions.</p>

      <h2>7. WhatsApp Communication</h2>
      <p>Our website includes a WhatsApp contact option for customer convenience.</p>
      <p>If you choose to communicate with us through WhatsApp, your interactions will also be subject to WhatsApp's own Privacy Policy and Terms of Service.</p>

      <h2>8. Sharing Your Information</h2>
      <p>We do not sell, rent or trade your personal information.</p>
      <p>We may share your information only where necessary with trusted service providers who assist us in operating our business, including:</p>
      <ul>
        <li>Google Workspace</li>
        <li>Google Sheets</li>
        <li>Google Analytics</li>
        <li>Instantly (for business email communication)</li>
      </ul>
      <p>These service providers are expected to handle your information responsibly and in accordance with applicable laws.</p>

      <h2>9. Data Retention</h2>
      <p>We retain personal information only for as long as necessary to:</p>
      <ul>
        <li>Respond to enquiries.</li>
        <li>Provide quotations.</li>
        <li>Maintain customer relationships.</li>
        <li>Comply with legal, accounting and tax obligations.</li>
        <li>Resolve disputes where applicable.</li>
      </ul>

      <h2>10. Cookies and Analytics</h2>
      <p>Our website uses Google Analytics to understand how visitors use our website and to improve user experience.</p>
      <p>Google Analytics may collect information such as browser type, device information, approximate location, pages visited and website interactions.</p>
      <p>This information is used only in aggregated form to analyse website performance and improve our services.</p>

      <h2>11. Third-Party Links</h2>
      <p>Our website may contain links to third-party websites, including WhatsApp and other external services.</p>
      <p>We are not responsible for the privacy practices or content of third-party websites.</p>
      <p>Users should review the respective privacy policies of those websites before providing personal information.</p>

      <h2>12. Data Security</h2>
      <p>We implement reasonable administrative, technical and organisational measures to protect personal information against unauthorised access, disclosure, alteration or destruction.</p>
      <p>However, no method of internet transmission or electronic storage is completely secure, and we cannot guarantee absolute security.</p>

      <h2>13. Your Rights</h2>
      <p>Subject to applicable law, you may request to:</p>
      <ul>
        <li>Access your personal information.</li>
        <li>Correct inaccurate information.</li>
        <li>Update your information.</li>
        <li>Request deletion of your personal information where legally permissible.</li>
        <li>Withdraw consent where processing is based on consent.</li>
      </ul>
      <p>To exercise these rights, please contact us using the details provided below.</p>

      <h2>14. Children's Privacy</h2>
      <p>Our website and services are intended for businesses and individuals aged 18 years or older.</p>
      <p>We do not knowingly collect personal information from children.</p>

      <h2>15. Indian Customers</h2>
      <p>Utsah currently provides products and services only within India.</p>
      <p>This Privacy Policy is intended to comply with applicable Indian laws, including the Digital Personal Data Protection Act, 2023, where applicable.</p>

      <h2>16. Changes to this Privacy Policy</h2>
      <p>We may update this Privacy Policy from time to time.</p>
      <p>Any changes will be published on this page together with the revised "Last Updated" date.</p>

      <h2>17. Contact Us</h2>
      <p>For questions regarding this Privacy Policy or your personal information, please contact:</p>
      <p>
        Kiran Ventures (Utsah)<br />
        54 Vinay Nagar<br />
        Kesar Bagh Road<br />
        Indore, Madhya Pradesh 452009<br />
        India
      </p>
      <p>Legal Email: <a href="mailto:atishaya@utsahgifting.com">atishaya@utsahgifting.com</a></p>
      <p>Customer Support: <a href="mailto:pragati@utsahgifting.com">pragati@utsahgifting.com</a></p>
      <p>Phone: +91 90988 80482</p>
    </LegalPage>
  );
}
